import $axios from '~/plugins/axios';
import type { Api, ProductType, ProductTypeRequest } from '~/api';
import { buildModule } from '../utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		itemsById: {} as Dict<ProductType>,
	})
	.withGetters({
		byId: (state) => (id: number) => state.itemsById[id],
	})
	.withMutations({
		STORE_PRODUCT_TYPE (state, item: ProductType) {
			state.itemsById = { ...state.itemsById, [item.id]: item };
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			const { data } = await api.get(`/product-type/${ id }`);
			commit('STORE_PRODUCT_TYPE', data.payload);
		},
		async create ({ commit }, payload: ProductTypeRequest) {
			const { data } = await api.post('/product-type', payload);
			commit('STORE_PRODUCT_TYPE', data.payload);
			return data.payload;
		},
		async update ({ commit }, { id, ...payload }: ProductTypeRequest & { id: number }) {
			const { data } = await api.put(`/product-type/${ id }`, payload);
			commit('STORE_PRODUCT_TYPE', data.payload);
			return data.payload;
		},
		async delete (_, id: number) {
			await api.delete(`/product-type/${ id }`);
		},
	});

